/* This file was auto generated by "icon-optimizer" */

import { DEV } from 'esm-env';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  'M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm-2 0a11 11 0 1 0 22 0 11 11 0 0 0-22 0Zm7-2a4 4 0 1 1 8 0c0 1.3-.8 2-1.6 2.6-.7.7-1.4 1.3-1.4 2.4h-2c0-1.8 1-2.5 1.8-3.2.6-.5 1.2-1 1.2-1.8a2 2 0 0 0-2-2 2 2 0 0 0-2 2H8Zm5 7a1 1 0 0 1-2 0v-1h2v1Z',
  DEV ? 'HelpIcon' : '',
  '',
  true,
);
